// import external dependencies
import 'jquery';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import axios from 'axios';
import cropper from './vendor/cropperjs/cropper.js';
import html2pdf from './vendor/html2pdf/dist/html2pdf.bundle.min.js';
import * as Cookies from "js-cookie";


// Import everything from autoload



document.addEventListener('DOMContentLoaded', () => {

  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {

    // Add a click event on each of them
    $navbarBurgers.forEach( el => {
      el.addEventListener('click', () => {

        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      });
    });
  }

  const homeannounce = Cookies.get('homeannounce');
  const announcemodal = document.getElementById('announcemodal');
  

  if (announcemodal) {
    const announcekylive = announcemodal.getAttribute('data');
    let homeannouncekey = Cookies.get('homeannouncekey');
    if (typeof homeannounce === 'undefined') {
      Cookies.set('homeannounce', 1);
      Cookies.set('homeannouncekey', announcekylive);
      announcemodal.classList.add('is-active');      
    } else {
      if (homeannouncekey != announcekylive) {
        announcemodal.classList.add('is-active');  
        Cookies.set('homeannouncekey', announcekylive);
      } else {
        announcemodal.classList.remove('is-active'); 
      }
    }
  }

  var btnsave = document.getElementById('btnsave');
  if (btnsave) {
    document.getElementById('btnsave').addEventListener ('click', resetEmotes, false);
  }

  var printbtn = document.getElementById('printbtn');
  if (printbtn) {
    document.getElementById('printbtn').addEventListener ('click', sendAPrint, false);
  }

  function sendAPrint() {
    var element = document.getElementById('Schedule');
    var opt = {
      filename: 'AwkwardAgent.pdf'
    };
    html2pdf(element, opt);
  }


  var termsmodal = document.getElementById('termsmodal');
  if (termsmodal) {
    console.log('here');
    document.getElementById('termsclick').addEventListener ('click', showTermModal, false);
  }

  function showTermModal() {
    var termsmodal = document.getElementById('termsmodal');
    termsmodal.classList.add('is-active');
  }

  var agentimg = document.getElementById('custom_field_9_info_container');
  if (agentimg) {
    let agentimgurl = $('#custom_field_9_info_container img').attr('src');
    agentimgurl = agentimgurl + `?v=${Math.random()}`;
    $('#custom_field_9_info_container .wppb-attachment-link').html('<img src="'+agentimgurl+'">');
  }

  var logoimg = document.getElementById('custom_field_10_info_container');
  if (logoimg) {
    let logoimgurl = $('#custom_field_10_info_container img').attr('src');
    logoimgurl = logoimgurl + `?v=${Math.random()}`;
    $('#custom_field_10_info_container .wppb-attachment-link').html('<img src="'+logoimgurl+'">');
  }

  // var teamname = document.getElementById('custom_field_2');
  // if (setteamname != '') {
  //   if (teamname) {
  //     document.getElementById("custom_field_2").value = setteamname;
  //   }
  // }

  // var teamownerform = document.getElementById('wppb-edit-user-user-customizations-team-owner');
  // teamownerform.addEventListener("submit", e => {
  //   var submittedteamname = document.getElementById('custom_field_2');
  //   console.log(submittedteamname);
  //   return true;
  // });
  
  // document.getElementById("custom_field_2").value = "My Value";

  function resetEmotes() {
    event.preventDefault();
    let boxurl = 'download?pdf=2534&printer=1';
    window.location.href = boxurl;
    
    setTimeout(function(){ 
        document.getElementById('spinner').className = 'spinner';
     }, 1000);

     setTimeout(function(){ 
        document.getElementById('spinner').className = 'spinner hide';
     }, 8000);
    
    return true;
  }


  window.onscroll = function() {reduceHeader()};

  function reduceHeader() {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      if (document.getElementById('awklogo') !=null) {
        document.getElementById('awklogo').className = 'collapse';
      }
      if (document.getElementById('tagline') !=null) {
        document.getElementById('tagline').className = 'collapse';
      }
      if (document.getElementById('remaxlogo') !=null) {
        document.getElementById('remaxlogo').className = 'collapse';
      }
      if (document.getElementById('myaccount') !=null) {
        document.getElementById('myaccount').className = 'myaccount collapse';
      }
      if (document.getElementById('headcontainer') !=null) {
        document.getElementById('headcontainer').className = 'container collapse';
      }
      if (document.getElementById('rangepicker') !=null) {
         document.getElementById('rangepicker').className = 'rangepicker collapse';
      }
    } else {
      if (document.getElementById('awklogo') !=null) {
        document.getElementById('awklogo').className = '';
      }
      if (document.getElementById('tagline') !=null) {
        document.getElementById('tagline').className = '';
      }
      if (document.getElementById('remaxlogo') !=null) {
        document.getElementById('remaxlogo').className = '';
      }
      if (document.getElementById('myaccount') !=null) {
        document.getElementById('myaccount').className = 'myaccount';
      }
      if (document.getElementById('headcontainer') !=null) {
        document.getElementById('headcontainer').className = 'container';
      }
      if (document.getElementById('rangepicker') !=null) {
        document.getElementById('rangepicker').className = 'rangepicker';
      }
    }
  }

});

let customfirstnameouter = document.getElementById('wppb-form-element-45');
let customfirstname = document.getElementById('custom_field_26');
let customlastnameouter = document.getElementById('wppb-form-element-46');
let customlastname = document.getElementById('custom_field_27');
let teamouter = document.getElementById('wppb-form-element-17');
let teamfield = document.getElementById('custom_field_2');
let customizeerror = document.getElementById('customizationerror');



if (customfirstname && customlastname && newplan == 0) {
  let customfirstnameval = customfirstname.value;
  let customlastnameval = customlastname.value;
  if (customfirstnameval && customlastnameval) {
   if (teamexist !=1 && agtst !=1 ) {
      customfirstname.readOnly = true;
      customlastname.readOnly = true;
      customfirstnameouter.classList.add('readonly');
      customlastnameouter.classList.add('readonly');
   } else  if (teamexist == 1 && agtst !=1 ) {
      teamfield.readOnly = true;
      teamouter.classList.add('readonly');
   }
  }
}

const addeailone = document.getElementById('custom_field_16');
if (addeailone) {
  addeailone.placeholder='Additional Email';
}

const addeailtwo = document.getElementById('custom_field_24');
if (addeailtwo) {
  addeailtwo.placeholder='Additional Email';
}

const recoverpassword = document.getElementById('wppb-recover-password');
if (recoverpassword) {
  document.getElementById('username_email').placeholder='Email';
}

 const mboxone = document.querySelectorAll('.mobilemenu .has-dropdown > a');
 for (let i = 0; i < mboxone.length; i++) {
     mboxone[i].addEventListener('click', (e) => { 
       var box = e.target.parentElement;
       box.classList.toggle('focus');
     });
 }

const termsbox = document.querySelectorAll('.terms');
const termsboxcover = document.querySelectorAll('.afreg_extra_fields h3');
for (let i = 0; i < termsbox.length; i++) {
  termsbox[i].addEventListener('scroll', (event) => { 
    let topmax = event.target.scrollTop + 100;
    let scrollMax = event.target.scrollHeight - event.target.clientHeight;
      if(topmax > scrollMax) {
        termsboxcover[0].classList.add('hide');
      } else {
        termsboxcover[0].classList.remove('hide');
      }
  });
}

const mboxtwo = document.querySelectorAll('.mobilemenu .has-dropdown .has-dropdown > a');
for (let i = 0; i < mboxtwo.length; i++) {
  mboxtwo[i].addEventListener('click', (e) => { 
    var link = e.target;
    link.classList.toggle('active');
    var box = e.target.nextElementSibling;
    box.classList.toggle('focus');
  });
}

const mboxthree = document.querySelectorAll('.mobilemenu .has-dropdown .has-dropdown .has-dropdown > a');
for (let i = 0; i < mboxthree.length; i++) {
  mboxthree[i].addEventListener('click', (e) => { 
    var link = e.target;
    link.classList.toggle('active');
    var box = e.target.nextElementSibling;
    box.classList.toggle('focus');
  });
}

const mboxfour = document.querySelectorAll('.mobilemenu .has-dropdown .has-dropdown .has-dropdown .has-dropdown > a');
for (let i = 0; i < mboxfour.length; i++) {
  mboxfour[i].addEventListener('click', (e) => { 
    var link = e.target;
    link.classList.toggle('active');
    var box = e.target.nextElementSibling;
    box.classList.toggle('focus');
  });
}

const cbox = document.querySelectorAll('.navbar-dropdown');
for (let i = 0; i < cbox.length; i++) {
  cbox[i].addEventListener('mouseenter', (e) => { 
    var parentitem = e.target.parentElement;
    parentitem.classList.add('hovered');
  });
  cbox[i].addEventListener('mouseleave', (e) => { 
    var parentitem = e.target.parentElement;
    parentitem.classList.remove('hovered');
  });
}

const thoughtsbox = document.querySelectorAll('.thoughtsouter .thoughtrow .thoughtcntrl > a');
for (let i = 0; i < thoughtsbox.length; i++) {
  thoughtsbox[i].addEventListener('click', (e) => { 
    e.preventDefault();
    var link = e.target;
    link.classList.toggle('active');
    var ptext = e.target.parentElement.nextElementSibling.childNodes[3];
    ptext.classList.toggle('active');
  });
}

const productclick = document.querySelectorAll('.woocommerce-product-gallery__image a');
for (let i = 0; i < productclick.length; i++) {
  productclick[i].addEventListener('click', (e) => { 
    e.preventDefault();
    const imgsrc = e.explicitOriginalTarget.src;
    $.fancybox.open('<img src="' + imgsrc + '">');
  });
}

const loginbox = document.querySelectorAll('.banner .container .myaccount > a');
for (let i = 0; i < loginbox.length; i++) {
  loginbox[i].addEventListener('click', (e) => { 
    e.preventDefault();
    var link = e.target.parentElement.nextElementSibling;
    link.classList.toggle('active');
  });
}

const marketinggliderExists = document.querySelector('.marketingswiper');
const glidergalleryExists = document.querySelector('.glidergallery');
const testimonialExists = document.querySelector('.testimonialsswiper');
const featureditemsExists = document.querySelector('.featureditems');

if (marketinggliderExists) {
  const carouselPrevButton = document.getElementById('caroulseprev');
  const carouselNextButton = document.getElementById('caroulsenext');

  var markswiper = new Swiper(".markSwiper", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 80,
    loop: true,
    autoplay: {
      delay: 5500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1,
        spaceBetween: 30
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 3,
        spaceBetween: 40
      },
    },
    navigation: {
      nextEl: carouselNextButton,
      prevEl: carouselPrevButton,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}

if (testimonialExists) {

  var testimonswiper = new Swiper(".testimonSwiper", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 80,
    loop: true,
    autoplay: {
      delay: 5500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}

const $custommodalclose = Array.prototype.slice.call(document.querySelectorAll('.modal-close'), 0);

if ($custommodalclose.length > 0) {
  $custommodalclose.forEach( el => {
    el.addEventListener('click', () => {
      const $allmodals = Array.prototype.slice.call(document.querySelectorAll('.modal'), 0);
      $allmodals.forEach( el => {
        el.classList.remove("is-active");
      });
    });
  });
}

const $custommodalbackclose = Array.prototype.slice.call(document.querySelectorAll('.modal-background'), 0);

if ($custommodalbackclose.length > 0) {
  $custommodalbackclose.forEach( el => {
    el.addEventListener('click', () => {
      const $allmodals = Array.prototype.slice.call(document.querySelectorAll('.modal'), 0);
      $allmodals.forEach( el => {
        el.classList.remove("is-active");
        removeAnnounce();
      });
    });
  });
}


// Galleries
const markgalleryExists = document.querySelector('.marketswiper');
if (markgalleryExists) {
  window.addEventListener('load', function(){

    let imgcnt = document.querySelectorAll('.marketingitemimg').length;
    const carouselFeatPrevButton = document.getElementById('caroulseprev');
    const carouselFeatNextButton = document.getElementById('caroulsenext');

    if (imgcnt) {
      if (imgcnt > 1) {
        var marksingleswiper = new Swiper(".marksingleSwiper", {
          modules: [Navigation, Pagination, Autoplay],
          slidesPerView: 1,
          spaceBetween: 80,
          loop: true,
          autoplay: {
            delay: 5500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          navigation: {
            nextEl: carouselFeatNextButton,
            prevEl: carouselFeatPrevButton,
          },
        });
      }
      
    }

  });

}

if (featureditemsExists) {


  const carouselFeatPrevButton = document.getElementById('caroulseprev');
  const carouselFeatNextButton = document.getElementById('caroulsenext');

  var featswiper = new Swiper(".featureSwiper", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 80,
    loop: true,
    autoplay: {
      delay: 5500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: carouselFeatNextButton,
      prevEl: carouselFeatPrevButton,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

}

function getParentNode(element, level=1) { // 1 - default value (if no 'level' parameter is passed to the function)
    while(level-- > 0) {
        element = element.parentNode.fullimgheight
        if(!element) {
            return null; // to avoid a possible "TypeError: Cannot read property 'parentNode' of null" if the requested level is higher than document
        }
    }
    return element;
}

function buildSmURL($str) {
  let url = '';
  let filename = $str.split('.').slice(0, -1).join('.');
  let ext = $str.substr($str.lastIndexOf('.') + 1);
  let imgurl = filename + "-250x250." + ext + `?v=${Math.random()}`;

  console.log('build');

  return imgurl;
}


// WEBPACK FOOTER //
// ./scripts/main.js